<dotlottie-player autoplay="true" loop="false" class="confetti-container" src="{{ lottieUrl }}"></dotlottie-player>
<div class="dialog-container">
  <span class="congrats-text">{{ headerText }}!</span>
  <span class="label">{{ bodyText }}</span>
  <div style="display: flex; flex-direction: row">
    <div [ngStyle]="{ 'padding-left': imagesUrl.length === 1 ? '0px' : imagesUrl.length === 2 ? '20px' : '40px' }"></div>
    @for (img of imagesUrl; track img; let i = $index) {
      <div>
        @if (i < 3) {
          <div style="position: relative" [ngStyle]="{ left: -20 * i + 'px' }">
            <img
              src="{{ DEPLOY_URL }}/assets/images/missing.png"
              class="sampling-img"
              [ngStyle]="{ filter: i === 2 && imagesUrl.length - i - 1 ? 'brightness(50%)' : 'brightness(100%)' }"
              appDeferImageLoad
              [imageSrc]="img" />
            @if (i === 2 && imagesUrl.length - i - 1) {
              <span class="extra-sampling-count">
                + {{ imagesUrl.length - i - 1 }}
              </span>
            }
          </div>
        }
      </div>
    }
  </div>
  <span class="price"
    ><b>{{ footerText }}</b></span
    >
    <hr style="width: 100%" />
    <div (click)="close()" class="text">YAY! THANKS</div>
  </div>
